import { render } from "./SectionLoader.vue?vue&type=template&id=4157175f"
import script from "./SectionLoader.vue?vue&type=script&lang=js"
export * from "./SectionLoader.vue?vue&type=script&lang=js"

const cssModules = {}
import style0 from "./SectionLoader.vue?vue&type=style&index=0&id=4157175f&lang=scss&module=true"
cssModules["$style"] = style0

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__cssModules',cssModules]])

export default __exports__